module.exports = __webpack_public_path__ + "static/img/yxl-font.1d04ff9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/yxl-font.svg
// module id = 1903
// module chunks = 115